import moment from "moment-timezone";

export const timezones: any = {
  "America/Chicago": "CT",
  "America/New_York": "ET",
  "America/Denver": "MT",
  "America/Los_Angeles": "PT",
  "Europe/Sarajevo": "CEDT",
  "Asia/Makassar": "WITA",
  "America/Anchorage": "AKDT",
  "Pacific/Honolulu": "HST",
  "Europe/Lisbon": "WET",
  "Europe/London": "GMT",
  "Europe/Berlin": "CET",
  "Europe/Bucharest": "EET",
  "": ""
};

const formatUtils = {
  prettyDate(date: string): string {
    return moment.utc(date, "YYYY-MM-DD HH:mm:ss").format("MMMM D");
  },
  prettyDateShort(date: string): string {
    return moment(date, "YYYY-MM-DD HH:mm:ss").format("MMM D Y");
  },
  prettyTime(time: string): string {
    return moment.utc(time, "YYYY-MM-DD HH:mm:ss").format("h:mm a");
  },
  prettyTimeWithTimezone(date: string | null, timezone: string | null): string {
    const { zone, offsetTime } = this.getTimeZoneDetails(timezone, date);
    return `${offsetTime.format("h:mm a")} ${timezones[zone]}`; // 2020-01-20 6:00 pm ET
  },
  timeOnly(time: string): string {
    return moment.utc(time ? time : "", "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss");
  },
  slashyDate(date: string): string {
    return moment(date).format("l");
  },
  formatAddress(group: any) {
    const address2 = group.address2 ? group.address2 + " - " : "";
    return `${group.address1} - ${address2}${group.city}, ${group.state} ${group.zip}`;
  },
  getTimeZoneDetails: function(timezone: any, date: string | null) {
    const zone = timezone?.split(" ")[0] || "";
    const offSet = timezone?.split(" ")[1] || "";
    const utcTime = moment.utc(date || "", "YYYY-MM-DD HH:mm:ss"); // 2000-01-01T23:30:00Z
    const offsetTime = utcTime.utcOffset(offSet); // 2000-01-01T18:30:00-05:00
    return { zone, offsetTime };
  },
  prettyDateTimeWithTimezoneAndYear(
    date: string | null,
    timezone: string | null,
    format: string = "ddd MMM D h:mm a YYYY"
  ): string {
    const { zone, offsetTime } = this.getTimeZoneDetails(timezone, date);
    return `${offsetTime.format(format)} ${timezones[zone]}`;
  },
  formatDateForLocalTimezone(date: string) {
    let localUtcOffset = moment().utcOffset();
    let localDate = moment.utc(date, "YYYY-MM-DD HH:mm:ss").utcOffset(localUtcOffset);
    return localDate.format("YYYY-MM-DD");
  }
};

export default formatUtils;
